import React from 'react'
import styled from '@emotion/styled'
import Buscamos from './buscamos'

const RightBarWrapper = styled.div`
  padding: 8px 16px 8px 0px;
  height: 100%;
`
const RightBarContainer = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  border-left: 1px #d0d0d0 solid;
  background-color: #383848;
  border-radius:5px;
  height: 100%;
`
const RightBar = () => <RightBarWrapper>
  <RightBarContainer>
    <Buscamos />
  </RightBarContainer>
</RightBarWrapper>

export default RightBar

